var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(0 0.638672)",
    fill: "url(#paint0_linear_935_1767)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_1767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 22.2637C14.4048 22.2637 14.125 22.5435 14.125 22.8887C14.125 23.2338 14.4048 23.5137 14.75 23.5137H17.25C17.5952 23.5137 17.875 23.2338 17.875 22.8887C17.875 22.5435 17.5952 22.2637 17.25 22.2637H14.75Z",
    fill: "#F8F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1875 7.26367C11.6342 7.26367 10.375 8.52287 10.375 10.0762V23.2012C10.375 24.7545 11.6342 26.0137 13.1875 26.0137H18.8125C20.3658 26.0137 21.625 24.7545 21.625 23.2012V10.0762C21.625 8.52287 20.3658 7.26367 18.8125 7.26367H13.1875ZM12.25 10.0762C12.25 9.55841 12.6697 9.13867 13.1875 9.13867H14.125V9.45117C14.125 9.96894 14.5447 10.3887 15.0625 10.3887H16.9375C17.4553 10.3887 17.875 9.96894 17.875 9.45117V9.13867H18.8125C19.3303 9.13867 19.75 9.5584 19.75 10.0762V23.2012C19.75 23.7189 19.3303 24.1387 18.8125 24.1387H13.1875C12.6697 24.1387 12.25 23.7189 12.25 23.2012V10.0762Z",
    fill: "#F8F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_935_1767",
    x1: -2.26046e-7,
    y1: 29.1589,
    x2: 32.5836,
    y2: 27.0708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_1767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6.63867)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMobile);
export default __webpack_public_path__ + "static/media/footer-mobile.8d0867daf4dd1a852c87c68608d4ab8a.svg";
export { ForwardRef as ReactComponent };